import React, { Component } from "react";
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

import AdminOnlyAccess from "../components/common/base/AdminOnlyAccess";
import OnboardingPresettingsTab from "./presettings/OnboardingPresettingsTab";
import KeyAccountPresettingsTab from "./presettings/KeyAccountPresettingsTab";

const TAB_ONBOARDING = "onboarding";
const TAB_KEY_ACCOUNT = "key_account";

class PreSettingsView extends Component {
  state = {
    activeTab: TAB_ONBOARDING,
  };

  toggleTab = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  render() {
    const { activeTab } = this.state;
    return (
      <AdminOnlyAccess>
        <div className="content">
          <Card>
            <CardHeader className="mb-2">
              <h5 className="card-category text-uppercase mb-2">Pre-Settings</h5>
            </CardHeader>
            <CardBody>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={activeTab === TAB_ONBOARDING ? "active" : ""}
                    onClick={() => this.toggleTab(TAB_ONBOARDING)}
                    style={{ cursor: "pointer" }}
                  >
                    Onboarding
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === TAB_KEY_ACCOUNT ? "active" : ""}
                    onClick={() => this.toggleTab(TAB_KEY_ACCOUNT)}
                    style={{ cursor: "pointer" }}
                  >
                    Key Account
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab} className="mt-4">
                <TabPane tabId={TAB_ONBOARDING}>{activeTab === TAB_ONBOARDING && <OnboardingPresettingsTab />}</TabPane>
                <TabPane tabId={TAB_KEY_ACCOUNT}>
                  {activeTab === TAB_KEY_ACCOUNT && <KeyAccountPresettingsTab />}
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </div>
      </AdminOnlyAccess>
    );
  }
}

export default PreSettingsView;
